import { createAction } from '@reduxjs/toolkit';

import { ArticleViewEvent } from '../analytics/events';
import { ArticleSuggestion } from '../types';
import {
  ArticleNavBackPayload,
  FetchLanguagesPayload,
  FetchTokenSuccessPayload,
  SetCompanyUidPayload,
  SetSearchTermPayload,
} from '../types/elevio.actions';

const prefix = 'elevio/suggestions';

export const suggestionActions = {
  setInitialConversationSuggestionState: createAction<{
    conversationId: number;
  }>(`${prefix}/setInitialConversationSuggestionState`),
  fetchTokenPending: createAction(`${prefix}/fetchTokenPending`),
  fetchTokenStart: createAction(`${prefix}/fetchTokenStart`),
  fetchTokenSuccess: createAction<FetchTokenSuccessPayload>(
    `${prefix}/fetchTokenSuccess`,
  ),
  fetchTokenError: createAction(`${prefix}/fetchTokenError`),
  subscriptionStatusSuccess: createAction(
    `${prefix}/subscriptionStatusSuccess`,
  ),
  subscriptionStatusError: createAction<{ errorMessage?: string }>(
    `${prefix}/subscriptionStatusError`,
  ),

  setCompanyUid: createAction<SetCompanyUidPayload>(`${prefix}/setCompanyUid`),
  clearTokenAndCompanyUid: createAction(`${prefix}/clearTokenAndCompanyUid`),
  setSearchInputValue: createAction<{ value: string; conversationId: number }>(
    `${prefix}/setSearchInputValue`,
  ),
  setSearchTerm: createAction<SetSearchTermPayload>(`${prefix}/setSearchTerm`),
  viewArticle: createAction<ArticleViewEvent>(`${prefix}/viewArticle`),
  articleNavBack: createAction<ArticleNavBackPayload>(
    `${prefix}/articleNavBack`,
  ),

  // language settings
  fetchAvailableLanguagesRequest: createAction(
    `${prefix}/fetchAvailableLanguagesRequest`,
  ),
  fetchAvailableLanguagesComplete: createAction<FetchLanguagesPayload>(
    `${prefix}/fetchAvailableLanguagesComplete`,
  ),
  fetchAvailableLanguagesFailure: createAction<{ errorMessage: string }>(
    `${prefix}/fetchAvailableLanguagesFailure`,
  ),
  setDetectedLanguageId: createAction<{
    conversationId: number;
    languageId: string;
  }>(`${prefix}/setDetectedDefaultLanguageId`),

  // Fetching suggestions
  fetchSuggestionsRequest: createAction(`${prefix}/fetchSuggestionsRequest`),
  fetchSuggestionsRequestWithoutTags: createAction(
    `${prefix}/fetchSuggestionsRequestWithoutTags`,
  ),
  fetchSuggestionsComplete: createAction<{
    conversationId: number;
    results: ArticleSuggestion[];
    unableToFindTaggedSuggestions: boolean;
  }>(`${prefix}/fetchSuggestionsComplete`),
  fetchSuggestionsFailure: createAction<{
    ticketId: number | null;
    // error: ErrorResponse;
    errorMessage: string;
  }>(`${prefix}/fetchSuggestionsFailure`),
  setUnableToFindTaggedSuggestions: createAction<{
    conversationId: number;
    unableToFindTaggedSuggestions: boolean;
  }>(`${prefix}/setUnableToFindTaggedSuggestions`),
};
